module.exports = __webpack_public_path__ + "static/img/banner-csr-03.d77387e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-03.jpg
// module id = vvjD
// module chunks = 100